import React from 'react';
import './Diameter.css';
import Diamete from '../../../imgs/Diamete.webp';

const Diameter = () => {
    return (
        <div className="Cavity-container">
            <div className='Cavitys'>
                <h2 className="Cavity-title">You need to learn some details about the PET preforms</h2>
                <div className="Cavity-content">

                    <p className="Cavity-text">
                        Information such as preform weight, the neck diameter of preform, daily capacity, etc. you want to produce. Based on this information, injection molding machine manufacturer will recommend suitable mold cavities and the model of the machine.
                    </p>
                </div>
                <div className="Cavity">
                    <img src={Diamete} alt="72 Cavity PET Preforms Machine" className="Cavity-image" />
                    <div className="Ordinary-content">
                        <h3 className="Cavity-title">Important points for choosing the right machine</h3>

                        <ul className="Ordinary-text">
                            <li>Sufficient clamping force</li>
                            <li>Pay attention to the actual injection volume and screw diameter of the machine</li>
                            <li>The tie-bar distance, mold height and minimum mold size should be considered</li>
                            <li>According to the size of the mold and preform, judge whether the opening stroke and ejection stroke are sufficient for product demoulding</li>
                        </ul>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default Diameter;
